angular.module('impactx.cscontract').controller('CSCBudgetsSchemasCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'TranslationService',
    'ToolbarService',
    'PartialDialogsService',
    '$redirect',
    CSCBudgetsSchemasCtrl
]);

function CSCBudgetsSchemasCtrl($scope, dataGen, $routeParams, ToastService, BackService, TranslationService, ToolbarService,
                               PartialDialogsService, $redirect) {
    var self = this;

    self.save = function ($event) {
        return dataGen.postAsForm({}, {budgets: $scope.data}, "/cscontract/budgets/save").then(function (response) {
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
            if (response && response.data && response.data.atpId) {
                $redirect.redirectTo(null, "/ruleuser/0/"+response.data.atpId+"/csc");
            }
            else {
                PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.cscId, 'cscbudgets', $routeParams.preSetId ? $routeParams.preSetId : 0);
            }
        });
    };

    dataGen.getData($scope, {cscId: $routeParams.cscId}, "/cscontract/budgets/view").then(function () {
        $scope.saveTrns = TranslationService.get("save");
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.saveTrns,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }
}